
import type { PrivacyZone, TrackPoint } from '../types';

export function getDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
  const R = 6371e3; // metres
  const φ1 = lat1 * Math.PI/180; // φ, λ in radians
  const φ2 = lat2 * Math.PI/180;
  const Δφ = (lat2-lat1) * Math.PI/180;
  const Δλ = (lon2-lon1) * Math.PI/180;

  const a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
            Math.cos(φ1) * Math.cos(φ2) *
            Math.sin(Δλ/2) * Math.sin(Δλ/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

  const d = R * c; // in metres
  return d;
}

/**
 * Checks if a point is inside any of the provided privacy zones.
 */
export const isInPrivacyZone = (lat: number, lon: number, zones: PrivacyZone[]): boolean => {
    if (!zones || zones.length === 0) return false;
    
    for (const zone of zones) {
        const dist = getDistance(lat, lon, zone.lat, zone.lon);
        if (dist <= zone.radius) {
            return true;
        }
    }
    return false;
};

/**
 * Masks track points that fall within privacy zones.
 * Returns a new array of track points with sensitive points removed.
 */
export const maskTrackData = (track: TrackPoint[], zones: PrivacyZone[]): TrackPoint[] => {
    if (!zones || zones.length === 0) return track;
    
    // Filter out points inside zones
    // Note: This creates gaps in the data (time jumps), which the visualizer handles by interpolation 
    // or we might want to split segments. For now, removing points is the standard approach.
    return track.filter(p => !isInPrivacyZone(p.lat, p.lon, zones));
};
